import React from "react";
import { Img } from "../../core/design-system/Img";
import { useTheme } from "../../../theme/ThemeProvider";
import { Text } from "../../core/design-system/Text";

const RegisterDebtView: React.FC = () => {
  const { theme } = useTheme();
  return (
    <div className="w-full flex flex-row rounded-lg bg-registerDebtBackground p-5 justify-start gap-2 items-center">
      <div className="w-1/4">
      <Img
        src={theme === "aub" ? "confidential.svg" : "img_confidential_1.svg"}
        className="w-[83px] h-[83px]"
        alt="wallet"
      />
      </div>
      <div className=" w-3/4 flex flex-row gap-2 items-center">
        <div className="flex flex-col ">
          <Text className="text-black font-normal text-left" size="lg" >
            {`Register for ${theme === "aub" ? "AUB" : "Soft"} Tokens`}
          </Text>
          <Text className="text-grey text-[14px] font-normal text-left">
            {`To authorise all your transactions`}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default RegisterDebtView;
